export {
  createExtensionRegistry,
  type ExtensionRegistryEntry,
  type ExtensionRegistrySnapshot,
} from "./registry.js";

